import productInstance from './instance'

const fetchProduct = (id) => {
  return productInstance.get('/products/' + id)
}

export default fetchProduct
